import { render, staticRenderFns } from "./zsbAcvitityFoot.vue?vue&type=template&id=dbfed49a&scoped=true&"
import script from "./zsbAcvitityFoot.vue?vue&type=script&lang=js&"
export * from "./zsbAcvitityFoot.vue?vue&type=script&lang=js&"
import style0 from "./zsbAcvitityFoot.vue?vue&type=style&index=0&id=dbfed49a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfed49a",
  null
  
)

export default component.exports